/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import { setFinanceRefundStatus } from '@/api/financial-center'
import { getMessageReviewById, setMessageReviewUserByMessageReviewId } from '@/api/message'
import { UserModule } from '@/store/modules/user'
import { Loading } from 'element-ui'
@Component({})
export default class RefundInfo extends Vue {
    logShow = true
    refundId = NaN
    refundInfo = null
    status = 1
    type = ''
    cancleReview = false
    reviewDialog = false
    opinion = '' // 审批意见
    reviewStatus: string = null //审批状态
    departmentId = NaN
    fileList: { name: string; url: string; uid?: number }[] = []
    editFileList = []
    editFiles = {
        account: null,
        price: null,
        refundAt: null,
        refundCause: null,
        financeRefundProofList: null,
    }
    isRequired = false
    messageReviewLogList = []
    disBtn=false
    types=''
    // 2023-2-23新增
    approvalVisible = false
    nodeType: string = null //驳回到哪个节点
    isSync: string = null //重新提交后触发E签宝/易快报
    stepNode = {
        isFirstNode: false,
        isSyncEkuaibao: false,
        isSyncEqianbao: false,
    }
    addSignShow = false
    transferShow = false
    previewVisible = false
    previewPath = ''
    previewName = ''
    approvedVisible = false // 审批通过
    approvedData = {}
    isAgreeRevoke = '' // 审批通过是否允许提交人撤回
    financeRefundAccount = {}
    financeRefundAccountType = ''
    loading = false
    isNotReject = false

    get userId() {
        return UserModule.userId
    }

    get elImageUrls() {
        return this.refundInfo ? this.refundInfo.financeRefundProofList.map(item => item.url) : []
    }

    created() {
        this.refundId = Number(this.$route.query.refundId)
        this.type = this.$route.query.type as string
        this.reviewStatus = this.$route.query.status as string
        this.types = this.$route.query.types as string
        this.getFinanceRefundById()
    }

    formatDate = formatDate


    handlePreview(file) {
        this.previewPath = file.url
        this.previewName = file.name
        this.previewVisible = true
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }

    async getFinanceRefundById() {
        this.loading = true
        const data: any = await getMessageReviewById(this.refundId,this.types).then((data: any)=>{
            this.refundInfo = data.result
            this.isNotReject = data.result.isNotReject == true ? false : true
            this.fileList = this.refundInfo.financeRefundProofList
            this.editFileList = data.result.editFileList
            this.editFiles.account = this.refundInfo.account
            this.editFiles.price = this.refundInfo.price
            this.editFiles.refundAt = this.refundInfo.refundAt
            this.editFiles.refundCause = this.refundInfo.refundCause
            this.editFiles.financeRefundProofList = this.refundInfo.financeRefundProofList
            if(this.editFileList && this.editFileList.length > 0) this.isRequired = this.type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
            this.$nextTick(() => {
                this.messageReviewLogList = this.refundInfo.messageReviewLogList
            })
            this.stepNode.isFirstNode = this.refundInfo.isFirstNode
            this.stepNode.isSyncEkuaibao = this.refundInfo.isSyncEkuaibao
            this.stepNode.isSyncEqianbao = this.refundInfo.isSyncEqianbao
            this.financeRefundAccount = this.refundInfo.financeRefundAccount
            this.financeRefundAccountType = (this.financeRefundAccount as any).type
            this.loading = false
        }).catch(err=>{
            this.loading = false
        })

    }

    // 验证当前字段是否可以编辑
    editFileShow(key: string) {
        if (this.reviewStatus !== '0' || this.type !== '0') return false
        return this.editFileList.some(item => item.file === key)
    }

    openReviewDialog(status: number) {
        this.editFiles.financeRefundProofList = this.fileList
        this.$set(this.approvedData, 'status', status)
        this.$set(this.approvedData, 'editFiles', this.editFiles)
        this.$set(this.approvedData, 'editFileList', this.editFileList)
        this.$set(this.approvedData, 'addData', this.fileList)
        this.$set(this.approvedData, 'isRequired', this.isRequired)
        this.$set(this.approvedData, 'approveId', this.refundId)
        // this.$set(this.approvedData, 'isSync', true)
        this.approvedVisible = true
    }

    async cancleReviewDialogConfirm() {
        await setFinanceRefundStatus({
            id: this.refundInfo.id,
            action: '1',
        })
        this.$message.success(`成功撤回审批`)
        setTimeout(() => { window.close() }, 1500)
    }

    closeReviewDialog() {
        this.reviewDialog = false
        this.opinion = ''
    }

    // reviewDialogConfirm() {
    //     const newObj = this.editFiles
    //     for(const key in newObj) {
    //         if(!this.editFileList.some(item => item.file === key)) delete newObj[key]
    //     }
    //     newObj.financeRefundProofList = this.fileList
    //     if(this.isRequired) {
    //         let bol = false
    //         for(const key in newObj) {
    //             if(!newObj[key] || newObj[key].length === 0) {
    //                 bol = true
    //                 break;
    //             }
    //         }
    //         if(bol && this.status === 1) {
    //             this.$message.error('请将编辑的信息填写完整')
    //             return
    //         }
    //     }
    //     const obj = {
    //         messageReviewId: this.refundId,
    //         status: this.status,
    //         opinion: this.opinion,
    //         addData: this.fileList,
    //         form: this.status === 1 ? newObj : {},
    //         nodeType: this.nodeType,
    //         isSync: this.isSync,
    //         // isRevoke: this.status === 1 ? this.isAgreeRevoke : ''
    //     }
    //     // 69 是财务部门的id
    //     // if(this.departmentId !== 69) delete obj.addData
    //     this.disBtn = true
    //     const loading = Loading.service({
    //         text: `审批${this.status === 1 ? '通过中' : '驳回中'}，请稍后`
    //     })
    //
    //     setMessageReviewUserByMessageReviewId(obj).then(() => {
    //         this.$message.success(this.status === 1 ? '审批通过' : '审批驳回')
    //         loading.close()
    //         setTimeout(() => {
    //             window.close()
    //         }, 1500)
    //     }).catch((err: Error) => {
    //         console.log(err)
    //         loading.close()
    //         this.disBtn = false
    //     })
    // }

    // approvedConfirm() {
    //     const newObj = this.editFiles
    //     newObj.financeRefundProofList = this.fileList
    //     for(const key in newObj) {
    //         if(!this.editFileList.some(item => item.file === key)) delete newObj[key]
    //     }
    //     if(this.isRequired) {
    //         let bol = false
    //         for(const key in newObj) {
    //             if(!newObj[key] || newObj[key].length === 0) {
    //                 bol = true
    //                 break;
    //             }
    //         }
    //         if(bol && this.status === 1) {
    //             this.$message.error('请将编辑的信息填写完整')
    //             return
    //         }
    //     }
    //     const obj = {
    //         messageReviewId: this.refundId,
    //         status: this.status,
    //         opinion: this.opinion,
    //         addData: this.fileList,
    //         form: this.status === 1 ? newObj : {},
    //         isRevoke: this.status === 1 ? this.isAgreeRevoke : ''
    //     }
    //     // 69 是财务部门的id
    //     // if(this.departmentId !== 69) delete obj.addData
    //     this.disBtn = true
    //     const loading = Loading.service({
    //         text: `审批${this.status === 1 ? '通过中' : '驳回中'}，请稍后`
    //     })
    //     setMessageReviewUserByMessageReviewId(obj).then(() => {
    //         this.$message.success(this.status === 1 ? '审批通过' : '审批驳回')
    //         loading.close()
    //         setTimeout(() => {
    //             window.close()
    //         }, 1500)
    //     }).catch((err: Error) => {
    //         console.log(err)
    //         loading.close()
    //         this.disBtn = false
    //     })
    // }
    uploadSuccess(res) {
        const { data } = res
        this.$message.success('上传成功')
        this.fileList.push({ name: data.name, url: data.ossUrl })
    }
    uploadError() {
        this.$message.error('上传失败')
    }
    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }



    // 驳回审批
    clickRejectButton(status: number) {
        this.$set(this.stepNode, 'status', status)
        this.$set(this.stepNode, 'approveId', this.refundId)
        this.$set(this.stepNode, 'isSync', true)
        this.approvalVisible = true
    }

    //     关闭审批弹框
    handleApprovalClose() {
        this.approvalVisible = false
    }

//    驳回弹框确认
    doApprovalConfirm(data) {
        // this.nodeType = data.rejectNode
        // this.opinion = data.reviewIdea
        // this.isSync = data.isTouchE
        // this.approvalVisible = false
        // this.reviewDialogConfirm()
        this.approvalVisible = false
    }

    /*
* 关闭转交弹框*/
    closeTransfer() {
        this.transferShow = false
    }

    /*
    * 转交弹框确认*/
    confirmTransfer() {
        this.transferShow = false
    }

    /*
    * 关闭加签*/
    closeAddSign() {
        this.addSignShow = false
    }

    /*
    * 确认加签*/
    confirmAddSign() {
        this.addSignShow = false
    }
    // 审批通过弹框取消
    handleApprovedClose(){
        this.approvedVisible = false
    }
    // 审批通过弹框确认
    doApprovedConfirm(data) {
        // this.opinion = data.reviewIdea
        // this.isAgreeRevoke = data.isAgreeRevoke
        // this.approvedVisible = false
        // this.approvedConfirm()
        this.approvedVisible = false
    }
}
